export default __webpack_public_path__ + "static/card2-2c241967e855a8eb4cb6c376742ab1e6.webp";